import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Mail, Phone } from "lucide-react";
export default function Footer() {
  return <footer data-section-id="10741" id="footer" className="dark bg-[#095fa3] text-white pt-16 pb-8">
      <div className="container mx-auto px-8">
        {}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-24 mb-16">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <img src="https://kanha.biz/wp-content/uploads/2026/03/cropped-sloth-look-left-no-bg.png" alt="Kanha ERP Logo" className="w-auto object-contain !h-[100px]" />
            </Link>
            <p className="font-sans text-sm leading-relaxed text-white/90 max-w-md">
              Kanha ERP provides mission-critical enterprise solutions tailored for modern government 
              agencies. Our platform ensures compliance, transparency, and operational excellence 
              across all institutional departments.
            </p>
            <div className="flex flex-col gap-3 mt-2">
              <div className="flex items-center gap-3 text-sm font-sans text-white">
                <Mail className="w-4 h-4 text-[#fb8c26] shrink-0" />
                <Link to="mailto:info@kanha.biz" className="hover:text-[#fb8c26] transition-colors">
                  info@kanha.biz
                </Link>
              </div>
              <div className="flex items-center gap-3 text-sm font-sans text-white">
                <Phone className="w-4 h-4 text-[#fb8c26] shrink-0" />
                <Link to="tel:+17207726420" className="hover:text-[#fb8c26] transition-colors">
                  +1-720-772-6420
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans text-[#fb8c26] font-bold text-base tracking-tight uppercase">
              ERP Solutions
            </h3>
            <nav className="flex flex-col gap-3">
              {[{
              label: "Public Finance Management",
              href: "#"
            }, {
              label: "Human Capital Management",
              href: "#"
            }, {
              label: "Procurement & Supply Chain",
              href: "#"
            }, {
              label: "Track and Trace Compliance",
              href: "#"
            }].map((link, i) => <Link key={i} data-index={i} to={link.href} className="font-sans text-sm text-white hover:text-[#fb8c26] transition-colors w-fit">
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-sans text-[#fb8c26] font-bold text-base tracking-tight uppercase">
              Agency Resources
            </h3>
            <nav className="flex flex-col gap-3">
              {[{
              label: "Digital Transformation Guides",
              href: "#"
            }, {
              label: "Compliance Reporting Tools",
              href: "#"
            }, {
              label: "Case Studies & White Papers",
              href: "#"
            }, {
              label: "Technical Support Portal",
              href: "#"
            }].map((link, i) => <Link key={i} data-index={i} to={link.href} className="font-sans text-sm text-white hover:text-[#fb8c26] transition-colors w-fit">
                  {link.label}
                </Link>)}
            </nav>
          </div>
        </div>

        {}
        <Separator className="bg-white/10 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          {}
          <nav className="flex flex-wrap justify-center md:justify-start gap-x-8 gap-y-4">
            {[{
            label: "ABOUT US",
            href: "/HomePage"
          }, {
            label: "CAREERS",
            href: "/HomePage"
          }, {
            label: "PARTNERS",
            href: "/HomePage"
          }, {
            label: "NEWS & MEDIA",
            href: "/HomePage"
          }, {
            label: "CONTACT US",
            href: "/#consultation-portal"
          }].map((link, i) => <Link key={i} data-index={i} to={link.href} className="font-sans text-xs font-medium text-white hover:text-[#fb8c26] transition-colors uppercase tracking-wider">
                {link.label}
              </Link>)}
          </nav>

          {}
          <p className="font-sans text-xs text-white/60 text-center md:text-right">
            © {new Date().getFullYear()} Kanha Technology Solutions. 3801 E. Florida Ave, Suite 102, Denver, CO 80210. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}